import React from 'react'
import Lottie from 'lottie-react';
import "./Mission_animation.css";


function Mission_animation  ({animationData})  {
  return (
     <section className='Mission_animation'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="arrow_lottie"
      />
    </section>
  )
}

export default Mission_animation;